module.exports = __webpack_public_path__ + "static/media/ktm_rotate_finger.2951934d.gif";